<!-- Left Hand Side -->
<div class="col-sm-3" id="locatetab">

	<!-- Header -->
	<h1 class="locate-page-header">
		<i class="fa fa-search" aria-hidden="true"></i> MONITOR TAGS 
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn-sm btn-ef dropdown-toggle" data-toggle="dropdown">
				Saved List(s) <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li [class.disabled]="!isAnyTagSelected() || isLoadingTagList">
					<a (click)="onSaveCurrentListClicked()">SAVE CURRENT LIST</a>
				</li>
				<li *ngIf="isAnySavedStoredListItemPresent()" class="divider"></li>
				<li *ngFor="let tagList of storedTagList" class="saved-tag-list-item" [class.disabled]="isLoadingTagList">
					<a class="col-sm-9" (click)="onTagListClicked(tagList)">{{ tagList?.name }}</a>
					<a class="col-sm-3" (click)="onDeleteClickedForStoredTagList(tagList)"><em class="fa fa-remove"></em></a>
				</li>
			</ul>
		</div>
	</h1>

	<!-- Tab Navigation (SELECT TAGS / SELECTED TAGS) -->
	<ul class="nav nav-tabs">
		<li class="active">
			<a data-toggle="tab" href="#selectTagsTab">
				SELECT TAGS
			</a>
		</li>
		<li>
			<a data-toggle="tab" href="#selectedTagsTab">
				SELECTED TAGS <span> ({{ tagsSelected.length }}) [{{ getCountOfSelectedTagsToBeDrawn() }}]</span>
			</a>
		</li>
	</ul>

	<!-- Tab Content (SELECT TAGS / SELECTED TAGS ) -->
	<div class="tab-content tab-section" style="border: 0px solid;">

		<!-- Select Tags Tab -->
		<div id="selectTagsTab" class="tab-pane fade in active">

			<!-- Select Tags Tab - Search Bar -->
			<div class="input-group locate-input">
				<input style="width: 75%" class="form-control" placeholder="Search for Tags..." 
					#selectTagsSearchInput [(ngModel)]="tagsToSelectSearchValue" [disabled]="isTagsToSelectSearchOptionChanging || isLoadingTagList">
				<select class="form-control" style="width: 25%" [(ngModel)]="selectedTagsToSelectSearchOption" [disabled]="isSearchingTagsToSelect || isLoadingTagList" (change)="onTagsToSelectSearchOptionChanged()">
					<option *ngFor="let searchOption of tagsToSelectSearchOptions" [ngValue]="searchOption">
						{{ (searchOption?.searchType == "NAME"? "NAME" : searchOption?.property?.name) }}
					</option>
				</select>
			</div>

			<!-- Select Tags Tab - Tag Information -->
			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Select Tags Tab Column Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px">
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										(click)="selectAllTagsToSelect($event.target.checked)"
										[checked]="isAllTagsToSelectSelected()"
										[disabled]="isSearchingTagsToSelect || isSelectingAllTagsToSelect || isLoadingTagList">
									<label></label>
								</div>
							</th>
							<th>NAME</th>
						</tr>
					</tbody>

					<!-- Select Tags Data - Display Tags for selection -->
					<tbody id="locateTableLocations">

						<!-- If searching for Tags... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingTagsToSelect; else selectTagsListTemplate">
							<div>Searching&nbsp;Tags...</div>
						</ng-container>

						<!-- Tags are not being searched for... Display the loaded Tags -->
						<ng-template #selectTagsListTemplate>
							<!-- Create the Tags to Select -->
							<ng-container *ngFor="let tag of tagsToSelect | paginate: {id: 'tag_pagination', itemsPerPage: tagsPerPage, currentPage: currentPage, totalItems: totalNumberOfTags }">
								<tr class="locateHeader">
									<!-- Checkbox -->
									<td>
										<div class="checkbox checkbox-inline">
											<input type="checkbox" class="styled"
												(click)="onTagToSelectToggled(tag, $event)"
												[disabled]="isSelectingAllTagsToSelect || isTagToSelectCheckboxBeingToggled(tag) || isLoadingTagList"
												[checked]="isTagToSelectSelected(tag)"
												>
											<label></label>
										</div>
									</td>
									<!-- Name -->
									<td>
										{{ tag?.name }}
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
				<!-- Pagination Controls for the "Tag" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="tag_pagination" (pageChange)="onPageChange($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>
		</div>
		<!-- End of Select Tags Tab -->

		<!-- Selected Tags Tab -->
		<div id="selectedTagsTab" class="tab-pane fade">

			<!-- Selected Tags Tab - Search Bar -->
			<div class="input-group locate-input">
				<input class="form-control" style="width: 75%; border: 0px solid;" placeholder="Search for something..." 
					#selectedTagsSearchInput [(ngModel)]="selectedTagsSearchValue" [disabled]="isSelectedTagsSearchOptionChanging || isLoadingTagList">
				<select class="form-control" style="width: 25%" [(ngModel)]="selectedTagsSearchOption" [disabled]="isSearchingSelectedTags || isLoadingTagList" (change)="onSelectedTagSearchOptionChanged()">
					<option *ngFor="let searchOption of tagsToSelectSearchOptions" [ngValue]="searchOption">
						{{ (searchOption?.searchType == "NAME"? "NAME" : searchOption?.property?.name) }}
					</option>
				</select>
			</div>

			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px;">
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										(click)="selectAllSelectedTags($event.target.checked)"
										[checked]="isAllSelectedTagsSelected()"
										[disabled]="isSelectingAllSelectedTags || isLoadingTagList">
									<label></label>
								</div>
							</th>
							<th style="width: 0px;">ICON</th>
							<th>NAME</th>
							<th>LOCATION</th>
							<th>ZONE</th>
						</tr>
					</tbody>

					<!-- Selected Tags Tab Data -->
					<tbody id="locateTableTags">

						<!-- If searching for Selected Tags... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingSelectedTags || isSelectedTagsSearchOptionChanging; else selectedTagsTemplate">
							<div>Searching&nbsp;Selected&nbsp;Tags...</div>
						</ng-container>

						<!-- Selected Tags are not being searched for... Display the Selected Tags -->
						<ng-template #selectedTagsTemplate>

							<!-- Create the Displays for each Tag -->
							<ng-container *ngFor="let tag of selectedTagsToDisplay">

								<!-- Main Label (Displayed by default) -->
								<tr  class="locateHeader">
									<!-- Checkbox -->
									<td style="width: 16px">
										<div class="checkbox checkbox-inline">
											<input type="checkbox" class="styled" 
												(click)="onSelectedTagToggled(tag, $event)"
												[disabled]="isSelectedTagBeingToggled(tag) || isLoadingTagList"
												[checked]="isSelectedTagSelectedToBeDisplayed(tag)" >
											<label></label>
										</div>
									</td>

									<!-- Icon -->
									<td style="width: 16px" (click)="onSelectedListHeaderClicked(tag)">
										<img [src]="getIconSource(tag)" />
									</td>

									<!-- Name -->
									<td (click)="onSelectedListHeaderClicked(tag)">
										{{tag.name}}
									</td>

									<!-- Location -->
									<td (click)="onSelectedListHeaderClicked(tag)">
										{{tag.locationInstance?.name}}
									</td>

									<!-- Zone -->
									<td (click)="onSelectedListHeaderClicked(tag)">
										{{tag.zoneInstance?.name}}
									</td>
								</tr>

								<!-- Display Body-->
								<tr id="{{ getIdForSelectedListDisplayBody(tag) }}" class="locateBody hidden" style="background-color: #2f2f2f">
									<td colspan="5">
										<table style="background-color: #2f2f2f; border: 0; width: 100%">
											<tbody>
												<!-- Image (only added if present) -->
												<tr class="user-image" *ngIf="isImagePresent(tag)">
													<td rowspan="10">
														<img class="table-user-image" [src]="getImageSource(tag)" />
													</td>
												</tr>
												<!-- Description -->
												<tr class="user-list">
													<td>{{tag.description}}</td>
												</tr>
												<!-- Data for Main Display Properties (Main Display = TRUE) -->
												<ng-container *ngFor="let datum of tag.data">
													<ng-container *ngIf="datum.property.mainDisplay == true">
														<tr>
															<td>{{ datum.property.name }}:</td>
															<td style="max-width: 400px">
																<ng-container *ngIf="datum.property.type == 'STRING'">
																	<ng-container *ngIf="datum.property.parameter == 'url'">
																		<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																	</ng-container>
																	<ng-container *ngIf="datum.property.parameter != 'url'">
																		{{ datum.value }}
																	</ng-container>
																</ng-container>
																<ng-container *ngIf="datum.property.type != 'STRING'">
																	{{ datum.value }}
																</ng-container>
															</td>
														</tr>
													</ng-container>
												</ng-container>
												<!-- END OF: Data for Main Display Properties (Main Display = TRUE) -->
												
												<!-- Action(s) Button / "Full Details" Expand / Hide -->
												<tr>
													<td>
													<!-- Commented out bottom until "Edit Data" and "Execute Function(s)" Actions are needed / implemented TODO: Implment this
														<div class="dropdown btn-group" style="display:inline-block">
															<button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown">Action(s)</button>
															<ul class="dropdown-menu">
																<li (click)="openDataDialog(tag)"><a>Edit Data</a></li>
																<ng-container *ngIf="isContainsFunctions(tag)">
																	<li class="divider"></li>
																	<ng-container *ngFor="let tagFunction of tag?.object?.functions">
																		<li (click)="openFunctionDialog(tag, tagFunction?.key)"><a>{{ tagFunction?.name }}</a></li>
																	</ng-container>
																</ng-container>
															</ul>
														</div>
													-->
													</td>
													<td style="text-align: end; color:red;" class="locateBody">
														<ng-container *ngIf="isFullDetailsNeeded(tag)">
															<span id="{{getIdForSelectedListHideFullDetails(tag)}}" style="display: none;" (click)="hideSelectedListFullDetails(tag)"> - Hide Full Details </span>
															<span id="{{getIdForSelectedListShowFullDetails(tag)}}" (click)="showSelectedListFullDetails(tag)"> + Show Full Details </span>
														</ng-container>												
													</td>
												</tr>
												<!-- END OF: Action(s) Button / "Full Details" Expand / Hide -->

												<!-- Full Details Display -->
												<tr id="{{getIdForSelectedListFullDetails(tag)}}" class="locateBody" *ngIf="isFullDetailsNeeded(tag)"
													style="display: none; background-color: #2f2f2f" >
													<td colspan="5">
														<table style="background-color: #2f2f2f; border: 0; width: 100%">
															<tbody>
																<ng-container *ngFor="let datum of tag.data">
																	<ng-container *ngIf="datum.property.mainDisplay == false && datum.property.hidden == false">
																		<tr>
																			<td>{{ datum.property.name }}:</td>
																			<td style="max-width: 400px">
																				<ng-container *ngIf="datum.property.type == 'STRING'">
																					<ng-container *ngIf="datum.property.parameter == 'url'">
																						<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																					</ng-container>
																					<ng-container *ngIf="datum.property.parameter != 'url'">
																						{{ datum.value }}
																					</ng-container>
																				</ng-container>
																				<ng-container *ngIf="datum.property.type != 'STRING'">
																					{{ datum.value }}
																				</ng-container>
																			</td>
																		</tr>
																	</ng-container>
																</ng-container>
															</tbody>
														</table>
													</td>
												</tr>
												<!-- END OF: Full Details Display-->
											</tbody>
										</table>
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
			</div>
		</div>
		<!-- End of Selected Tags Tab -->
	</div>
	<!-- End of Tabs Content -->
</div>
<!-- End of Left Hand Side -->

<!-- Right Hand Side -->
<div class="col-sm-9" style="margin: -10px 0 0 0; padding: 0; height: calc(100vh - 50px); overflow-y: hidden; background-image: url(assets/images/map_bg.png)">
	
	<!-- Display the available Locations to be the Map -->
	<div id="locationsWell" class="well" style="margin-bottom: 0; opacity: 0.8; border-right: 0px; border-left: 0px;">
		<ng-container *ngFor="let location of locationsToDisplay">
			<button type="button" class="btn" 
				[class.btn-primary]="location?.id == locationBeingDisplayed?.id" 
				[class.btn-secondary]="location?.id != locationBeingDisplayed?.id"
				(click)="onLocationClicked(location)"
				>
				{{ location?.name }} 
				<span class="badge badge-light badge-round"> {{ getSelectedTagsInLocation(location).length }} </span>
			</button>
		</ng-container>
	</div>
	
	<!-- Map where everything is drawn -->
	<app-new-map #locateMap class="locate-map" 
		(onTagClicked)="onTagClickedOnMap($event)"
		>
	</app-new-map>
</div><!-- end of col-sm-8 -->

<!-- Popup Dialog used to execute Function Action(s) on Tags -->
<ef-instance-function-popup
	(functionCompletedSuccessfullyEvent)="onFunctionCompletedSuccessfully($event)"
	>
</ef-instance-function-popup>

<!-- Popup Dialog used execute the "Edit Data" Action on Tags -->
<ef-instance-data-dialog
	(updateCompletedSuccessfullyEvent)="onDataUpdatedSuccessfully($event)"
	>
</ef-instance-data-dialog>

<!-- Popup Dialogs for each tracked instances  -->
<ng-container *ngFor="let tag of getSelectedTagsInLocation(locationBeingDisplayed)">
	<ef-tag-locate-popup
		[tag]="tag"
		[dialogId]="getIdForPopup(tag)"
		[hideEmitter]="getHideEmitter(tag)"
		>
	</ef-tag-locate-popup>
</ng-container>

<!-- Save Tag List Dialog -->
<ef-save-tag-list-dialog
	(saveClicked)="onSaveTagListDialogSaveClicked($event)"
	(cancelClicked)="onSaveTagListDialogCancelClicked()"
	>	
</ef-save-tag-list-dialog>

<!-- Simple Confirm Dialog used to confirm deletions from the Stored Tag List -->
<ef-simple-confirm-dialog
	(confirmClicked)="onConfirmDialogConfirmClicked()"
	(cancelClicked)="onConfirmDialogCancelClicked()"
	>
</ef-simple-confirm-dialog>
